import useGetUserRole from "../hooks/useGetUserRole";
import { UserRole } from "../lib/models/enums";

export interface ShowForRoleProps {
  roles: UserRole[];
  children: JSX.Element;
  hideForAdmin?: boolean;
}

function ShowForRole({ children, roles, hideForAdmin }: ShowForRoleProps) {
  const userRole = useGetUserRole();

  if (userRole === "Administrator" && !hideForAdmin) return children;

  for (const role of roles) {
    if (role === userRole) {
      return children;
    }
  }

  return null;
}

export default ShowForRole;
